<template>
  <v-card :disabled="loading" v-bind="$attrs">
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <v-form @submit.prevent="submit">
        <v-card-title>
          Cliente
          <v-spacer></v-spacer>
          <v-btn @click="cancel" icon v-if="closeable">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <ValidationProvider
            :rules="{ required: true, max: 255 }"
            v-slot="{ errors }"
            name="nome"
          >
            <v-text-field
              v-model="form.name"
              label="Nome"
              counter="255"
              autofocus
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            :rules="{ required: true, max: 255, email: true }"
            v-slot="{ errors }"
            name="email"
          >
            <v-text-field
              v-model="form.email"
              label="Email"
              counter="255"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            :rules="{ required: true, max: 100 }"
            v-slot="{ errors }"
            name="documento fiscal"
          >
            <v-text-field
              v-model="form.fiscal_number"
              label="Documento Fiscal"
              counter="100"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>
        </v-card-text>

        <v-subheader>ENDEREÇO</v-subheader>

        <v-card-text>
          <ValidationProvider
            :rules="{ required: false, max: 255 }"
            v-slot="{ errors }"
            name="linha 1"
          >
            <v-text-field
              v-model="form.address_1"
              label="Linha 1 (opcional)"
              counter="255"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            :rules="{ required: false, max: 255 }"
            v-slot="{ errors }"
            name="linha 2"
          >
            <v-text-field
              v-model="form.address_2"
              label="Linha 2 (opcional)"
              counter="255"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            :rules="{ required: false, max: 255 }"
            v-slot="{ errors }"
            name="linha 3"
          >
            <v-text-field
              v-model="form.address_3"
              label="Linha 3 (opcional)"
              counter="255"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            :rules="{ required: false, max: 255 }"
            v-slot="{ errors }"
            name="linha 4"
          >
            <v-text-field
              v-model="form.address_4"
              label="Linha 4 (opcional)"
              counter="255"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancel" text>Cancelar</v-btn>
          <v-btn
            type="submit"
            :disabled="invalid"
            color="primary"
            :loading="loading"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-form>
    </ValidationObserver>
  </v-card>
</template>

<script>
const INITIAL_DATA = {};

export default {
  props: {
    closeable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      form: INITIAL_DATA,
      loading: false
    };
  },

  methods: {
    init(form = null) {
      this.form = form ? form : { ...INITIAL_DATA };
      this.$refs.form.reset();
    },

    cancel() {
      this.$emit("cancel");
    },
    async submit() {
      this.$emit("submit", this.form);
    }
  }
};
</script>
